import validatePrefillData, { TPrefillData } from "../models/prefillData";

const decodePrefillData = (data: string): TPrefillData | null => {
  if (typeof window === "undefined" || typeof window.atob === "undefined") {
    return null;
  }
  try {
    const parsedData = JSON.parse(decodeURIComponent(window.atob(decodeURIComponent(data))));
    return validatePrefillData(parsedData);
  } catch (err) {
    console.error("Failed to decode order prefill data", err);
    return null;
  }
};
export default decodePrefillData;
